import { Instance } from '@funtech-int/rival';

import { RumManager, rumManagerRef } from '.';

export function createRumClientManager(): Instance<RumManager> {
    const rum = window.Ya?.Rum;

    return {
        ref() {
            return rumManagerRef;
        },

        setPage(page: string) {
            if (rum) {
                rum.setVars({
                    '-page': page,
                });

                const errorSettings = rum._errorSettings || {};
                rum.updateErrors({
                    ...errorSettings,
                    page,
                });
            }
        },

        logEventFloat(name, value, additional) {
            if (rum) {
                rum.logEventFloat(name, value, { additional });
            }
        },

        toString() {
            throw new Error('Method not implemented.');
        },
    };
}
